import type { Breadcrumb } from "@core/schema/Breadcrumb.js";
import type { MenuItem } from "@core/schema/MenuItem.js";

export function isMenuActive(menuItem: MenuItem | Breadcrumb, currentPath: string): boolean {
	return menuItem.href !== undefined && new URL(menuItem.href, "https://example.com").pathname === currentPath;
}
